/** Attach the browser's leave confirmation only while there is unsaved work. */
export function installUnsavedChangesGuard(
  target: EventTarget,
  hasUnsavedChanges: () => boolean,
  subscribe: (listener: () => void) => () => void
) {
  let attached = false
  const beforeUnload = (event: Event) => {
    if (!hasUnsavedChanges()) return
    event.preventDefault()
    ;(event as BeforeUnloadEvent).returnValue = 'unsaved'
  }
  const refresh = () => {
    const dirty = hasUnsavedChanges()
    if (dirty === attached) return
    attached = dirty
    if (dirty) target.addEventListener('beforeunload', beforeUnload)
    else target.removeEventListener('beforeunload', beforeUnload)
  }
  const unsubscribe = subscribe(refresh)
  refresh()
  return () => {
    unsubscribe()
    target.removeEventListener('beforeunload', beforeUnload)
  }
}
